import React from "react";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaMobileAlt,
  FaBatteryHalf,
  FaTint,
  FaChargingStation,
} from "react-icons/fa";

import "./CTA.css";
import { siteData } from "../../data/siteData";

function CTA() {
  return (
    <section className="cta-section">
      <div className="container" data-aos="zoom-in">
        <div className="cta-card">
          <h2 className="cta-title">Need Mobile Repair Today?</h2>

          <p className="cta-subtitle">
            Fast, professional doorstep mobile repair service anywhere in UAE.
          </p>

          <div className="cta-services">
            <div className="cta-service">
              <FaMobileAlt />
              <span>Screen Repair</span>
            </div>

            <div className="cta-service">
              <FaBatteryHalf />
              <span>Battery Replacement</span>
            </div>

            <div className="cta-service">
              <FaTint />
              <span>Water Damage</span>
            </div>

            <div className="cta-service">
              <FaChargingStation />
              <span>Charging Issues</span>
            </div>
          </div>

          <div className="cta-buttons">
            <a
              href={`https://wa.me/${siteData.whatsapp.replace("+", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn cta-whatsapp-btn"
            >
              <FaWhatsapp />
              WhatsApp Us
            </a>

            <a href={`tel:${siteData.phone}`} className="btn cta-call-btn">
              <FaPhoneAlt />
              Call Now
            </a>
          </div>

          <div className="cta-note">Available 7 Days A Week</div>
        </div>
      </div>
    </section>
  );
}

export default CTA;
